import {Typography} from '@mui/material';
import {ReactComponent as CheckmarkIcon} from '../../../../assests/svg/checkmark-blue.svg';
import {
  STEP_PROCESSING_STATUS,
} from '../AurPizzaTrackerProgress';
import {t} from 'i18next';

interface Props {
  currentStepNo: string; // Pass current step no of pulse
  isLastStep: boolean; // Set true if rendering last step
  size?: number; // have default size 70. set it if need to increase or decrese size
  status?: string; /// this is parent status of Progress like "Queued" | "Processing" | "Filtering" | "Exporting" and used to define test id and accibility lable
  stepProcessingStatus?: STEP_PROCESSING_STATUS;
}
const calculateDynamicStepSize = (size: number) => {
  /**
   * dont't change this initital base value for componen.
   * if need to increase size of Pulse container then use size prop for it.
   * Respective value will be dynamically calculated based on prop size value
   */
  const baseOuterSize = 70;
  const baseContainerSize = 54;
  const basePulseSize = 48;
  const baseCompletedBlurSize = 62;

  return {
    outerSize: size,
    containerSize: (baseContainerSize / baseOuterSize) * size,
    pulseSize: (basePulseSize / baseOuterSize) * size,
    completedBlurSize: (baseCompletedBlurSize / baseOuterSize) * size,
  };
};

export const PulseStepTestIDS = {
  PULSE_ANIMATION_CONTAINER: 'pulse-animation-container',
  COMPLETED_GRADIENT_CONTAINER: 'completed-gradient-container',
  CONTENT_CONTAINER: 'content-container',
  PULSE_ANIMATION_ERROR_CONTAINER: 'pulse-animation-error-container',
};

const PulseStep: React.FC<Props> = ({
  currentStepNo,
  isLastStep,
  size = 70,
  status,
  stepProcessingStatus,
}) => {
  const dynamicSize = calculateDynamicStepSize(size);

  const renderPulseBG = () => {
    /** Show animated pulse effect with error state */
    if (stepProcessingStatus === 'Failed') {
      return (
        <div
          data-testid={PulseStepTestIDS.PULSE_ANIMATION_ERROR_CONTAINER}
          className="pulse pulse-error"
          style={{width: dynamicSize.pulseSize, height: dynamicSize.pulseSize}}
          role="status"
        />
      );
    }

    /** Show animated pulse effect using css class if step is in progress state */
    if (stepProcessingStatus === 'InProgress')
      return (
        <div
          data-testid={PulseStepTestIDS.PULSE_ANIMATION_CONTAINER}
          className="pulse"
          style={{width: dynamicSize.pulseSize, height: dynamicSize.pulseSize}}
          role="status"
        />
      );

    /** Show Background gradient view if step is last and it's completed */
    if (isLastStep && stepProcessingStatus === 'Completed') {
      return (
        <div
          data-testid={PulseStepTestIDS.COMPLETED_GRADIENT_CONTAINER}
          role="status"
          className="completed-pulse"
          style={{
            width: dynamicSize.completedBlurSize,
            height: dynamicSize.completedBlurSize,
          }}
        />
      );
    }
  };

  return (
    <div
      className="pulse-outer-container"
      style={{width: dynamicSize.outerSize, height: dynamicSize.outerSize}}
      data-testid={`pulse-step-id-${status}-${currentStepNo}`}
      aria-hidden
    >
      {renderPulseBG()}

      {/** Show checkmark at top if step is completed else show step number */}
      <div
        className={`container${stepProcessingStatus === 'InProgress' || stepProcessingStatus === 'Completed' ? ' container-active' : ''} ${stepProcessingStatus === 'Failed' ? ' container-error' : ''}`}
        style={{
          width: dynamicSize.containerSize,
          height: dynamicSize.containerSize,
        }}
        data-testid={PulseStepTestIDS.CONTENT_CONTAINER}
      >
        {stepProcessingStatus === 'Completed' ? (
          <CheckmarkIcon aria-label={t('common.stepCompletedIcon')} />
        ) : (
          <Typography
            className={`typo-text headline3_size step-text ${stepProcessingStatus === 'Failed' ? 'step-error' : ''}`}
          >
            {currentStepNo}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PulseStep;
